import { type IStatusProps } from 'shared/ui/Status'
import { type IPaymentStatus } from 'entities/Billing/api/types'

export const paymentStatusConfig: Record<IPaymentStatus, IStatusProps> = {
  pending: {
    title: 'Pending',
    icon: 'clock',
    emphasis: 'high',
    intent: 'informative',
  },
  succeeded: {
    title: 'Paid',
    icon: 'check2',
    emphasis: 'high',
    intent: 'positive',
  },
  failed: {
    title: 'Failed',
    icon: 'closeCircle',
    emphasis: 'high',
    intent: 'negative',
  },
  refunded: {
    title: 'Refunded',
    icon: 'back2',
    emphasis: 'high',
    intent: 'neutral',
    iconColor: 'var(--content-primary-tertiary)',
  },
}

export type PaymentStatusKey = keyof typeof paymentStatusConfig
